import { render, staticRenderFns } from "./gestores.vue?vue&type=template&id=3c2221aa&scoped=true&"
import script from "./gestores.vue?vue&type=script&lang=js&"
export * from "./gestores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2221aa",
  null
  
)

export default component.exports